export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-100"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20editorial%20illustration%20with%20warm%20coral%20and%20amber%20gradients%20flowing%20organic%20shapes%2C%20soft%20layered%20curves%20and%20circles%20blending%20seamlessly%2C%20minimalist%20geometric%20elements%2C%20news%20and%20social%20media%20vibe%2C%20clean%20composition%20with%20floating%20translucent%20spheres%2C%20editorial%20design%20aesthetic%2C%20warm%20neutral%20backdrop%20with%20subtle%20texture%2C%20high%20detail%2C%20harmonious%20color%20palette%20of%20terracotta%20coral%20amber%20and%20cream&width=1600&height=900&seq=hero-bg-91cg&orientation=landscape"
          alt="91吃瓜主视觉背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>实时更新 · 一站直达</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight">
              91吃瓜 — 最新娱乐八卦与热点导航平台
            </h1>

            <p className="mt-4 text-lg md:text-xl text-background-50/90 leading-relaxed max-w-xl mx-auto lg:mx-0">
              聚合全网娱乐热点与八卦资讯，覆盖明星动态、影视综瓜、社会热闻与网络热议事件。
            </p>

            <p className="mt-3 text-sm md:text-base text-background-50/75 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              每日同步更新最新网址入口，确保吃瓜群众随时随地快速访问91吃瓜网、91吃瓜在线与91吃瓜官网，绝不错过任何一个劲爆大瓜。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-6">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></div>
                <span className="text-sm text-background-50/80">每日更新超200条热点</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></div>
                <span className="text-sm text-background-50/80">覆盖12大娱乐分类</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></div>
                <span className="text-sm text-background-50/80">多线路入口稳定访问</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all text-base"
              >
                <i className="ri-compass-3-line text-lg"></i>
                开始吃瓜
              </a>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium rounded-full border border-background-50/30 hover:bg-background-50/25 transition-all text-base"
              >
                <i className="ri-grid-line text-lg"></i>
                查看专题汇总
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none flex items-center justify-center">
            <div className="relative w-72 h-72 md:w-80 md:h-80 lg:w-[420px] lg:h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20editorial%20illustration%20of%20a%20smartphone%20screen%20showing%20entertainment%20news%20feed%20with%20colorful%20cards%2C%20trending%20topics%20and%20hot%20gossip%20icons%2C%20floating%20notification%20bubbles%20around%20the%20screen%2C%20warm%20coral%20and%20amber%20accent%20colors%2C%20clean%20modern%20UI%20design%20elements%2C%20social%20media%20browsing%20concept%2C%20editorial%20flat%20vector%20style%20with%20soft%20shadows%2C%20cream%20background%2C%20high%20detail%2C%20chic%20and%20trendy%20composition&width=840&height=840&seq=hero-main-91cg&orientation=squarish"
                alt="91吃瓜平台入口展示"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}